import { render, staticRenderFns } from "./SolicitudesCambioProgramaListado.vue?vue&type=template&id=c8063ee8"
import script from "./SolicitudesCambioProgramaListado.vue?vue&type=script&lang=js"
export * from "./SolicitudesCambioProgramaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports